import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import { styled } from '@mui/system';
import { OutlinedInput } from '@mui/material';

const StyledTextField = styled(OutlinedInput,
  {
    name: "StylesTextField"
  })
  ({
    "& .MuiOutlinedInput-notchedOutline": {
      border: '1px solid #003F60',
      borderRadius: '4px',
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: '1px solid #003F60',
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: '1px solid #003F60',
    },
    "& .MuiInputBase-input": {
      padding: '5px 10px',
      color: '#0C243F',
      fontSize: '16px',
      fontFamily: 'Montserrat',
    },
  });

const BorderTextField = (props) => {
  
  const onValueChange = (e) => {
    const { name, value } = e.target;
    if ((name === "email" || name === "username") && value) {
      // Replace smart single quote with regular apostrophe to support user email containing apostrophe in it. 
      // https://developer.apple.com/forums/thread/89706
      e.target.value = value.replace(/[\u2018\u2019]/g, "'");
    };
    props.onChange(e);
  };

  return (
    <>
      <InputLabel className="border-text-field-label">{props.label}</InputLabel>
      <StyledTextField
        fullWidth
        id={props.id}
        type={props.type}
        name={props.id}
        // label={props.label}
        placeholder={props.placeholder}
        error={
          props?.errorData?.dirty && props?.errorData?.error ? true : undefined
        }
        helperText={
          props?.errorData?.dirty && props?.errorData?.error
            ? props?.errorData?.message
            : ''
        }
        value={props.value}
        onChange={onValueChange}
        onBlur={props.onBlur}
        disabled={props.disabled}
        inputProps={props.inputProps}
        multiline={props.multiline}
        rows={props.rows}
        className={props.className}
      // variant="filled" 
      // sx={{
      //   "& .MuiInputBase-root": {
      //     background: '#d9d9d9',
      //     height:'40px',
      //     border:'none',
      //   }
      // }}
      />
      {props?.errorData?.dirty && props?.errorData?.error && props?.errorData?.message &&
        <div className='mt-1 label-error'>{props?.errorData?.message}</div>
      }
    </>
  );
};

export default BorderTextField;
